import angular from 'angular';

import '../../../services/user';

angular.module('folkeuni').component('passwordReset', {
  bindings: {
    loginPageUrl: '@',
    myPageUrl: '@',
    siteId: '@',
    token: '@',
    user: '@'
  },
  controller: function(User, $timeout) {
    var $ctrl = this;

    $ctrl.passwordReset = function() {
      $ctrl.statusMessage = null;
      $ctrl.loading = true;
      $ctrl.success = null;
      $ctrl.error = null;
      var valid = true;

      if(angular.isUndefined($ctrl.password)){
        valid = false;
        $ctrl.loading = false;
        $ctrl.error = true;
        $ctrl.statusMessage = "Password må ikke være tom";
      }
      else if ($ctrl.password != $ctrl.passwordConfirm) {
        valid = false;
        $ctrl.loading = false;
        $ctrl.error = true;
        $ctrl.statusMessage = "Password matcher ikke";
      }

      if (valid) {
        var passwordObj = {
          email: $ctrl.user,
          password: $ctrl.password,
          siteId: $ctrl.siteId,
          token: $ctrl.token
        }

        User.passwordReset(passwordObj).then(function(successResponse) {
          $ctrl.loading = false;
          $ctrl.success = true;
          $ctrl.statusMessage = "Vi har opdateret dit password, og har logget dig ind.<br/>Om 3 sekunder vil du blive viderstillet til 'Min side'";
          $timeout(function() {
             window.location.href = $ctrl.myPageUrl
          }, 3000)
        }, function(errorResponse) {
          console.log("Error", errorResponse);
          $ctrl.loading = false;
          $ctrl.error = true;
          $ctrl.statusMessage = "Der er sket en fejl i forbindelse med nulstillingen, er e-mail indtastet korrekt?";
        })
      }
    }
  },
  templateUrl: '/shop-dist/templates/user-reset-password.html',
  transclude: false
});
